<template>
    <div class="main-content__wizzard">
        <div class="wizzard__content">
            <h2 class="wizzard__step-title" v-translate>
                What is your planned activity?
            </h2>
                <input-field label="Activity name" type="text" :field="$v.activity.name"/>
                <input-field label="Describe your activity" type="textarea" :field="$v.activity.description"/>

                <div class="form__group-category">
                    <div class="your-dates__category">
                        <span class="main-category-icon" :class="iconClass"></span>
                    </div>
                    <input-field label="Category" type="select2" :field="$v.activity.category" :options="categoryOptions" />
                    <input-field label="Subcategory" type="select2" :field="$v.activity.subcategory" :alwaysfocus="true" :options="subcategoryOptions" />
                </div>
                <div class="form__action-buttons">
                    <a @click="submit()" href="javascript:;" class="button button--primary" v-translate>Next step</a>
                </div>
        </div>
        <div class="wizzard__tips">
            <h2 v-translate>Quick tips</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid aperiam eligendi eos facilis
                illo, ipsa iste, laboriosam laudantium porro qui similique, sit suscipit tempore vero voluptate.
                Eaque impedit porro quae.</p>
            <p>Ab adipisci deserunt eius expedita explicabo, facilis, in mollitia natus provident quam quisquam,
                quo reiciendis repudiandae temporibus vel velit voluptate. Adipisci ducimus eligendi itaque,
                nesciunt pariatur perferendis rerum totam voluptates.</p>
        </div>
    </div>
</template>
<script>
    import InputField from "../../views/popups/InputField";
    import {required} from 'vuelidate/lib/validators';
    import CategoryOptions from "../../mixins/CategoryOptions";
    import ActivityClass from "../../mixins/ActivityClass";

    export default {
        name: 'plan-activity-step-one',
        mixins: [CategoryOptions, ActivityClass],
        components: {InputField},
        data() {
            return {
                activity: {}
            }
        },
        props: {
            parent_activity: {},
        },
        beforeMount: function() {
            this.activity = this.parent_activity
        },
        methods: {
            submit: function() {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.$emit('advance', 'step-2')
                }
            }
        },
        validations: {
            activity: {
                name: {required},
                description: {},
                category: {required},
                subcategory: {required}
            }
        }
    }
</script>